<template>
  <v-layout
    align-center
    :style="{
      'min-width': small ? '48px' : 'initial',
      'min-height': small ? '24px' : 'initial',
      'max-width': small ? '48px' : 'initial',
      'max-height': small ? '24px' : 'initial',
    }"
    :class="{clickable: small}"
    @click="small ? onSmallWidgetClicked() : null"
  >
    <v-layout style="max-width: 24px; margin-right: 9px">
      <img
        :src="`/static/locale/${$i18n.locale}.png`"
        width="24"
        height="24"
        :class="{'mr-1': small}"
      >
      <v-icon
        v-if="small"
        :class="{'white--text': dark}"
      >
        keyboard_arrow_down
      </v-icon>
    </v-layout>
    <v-select
      ref="select"
      item-text="displayName"
      item-value="locale"
      :label="$t('language')"
      :items="locales"
      :value="$i18n.locale"
      :class="{small: small}"
      data-cy="language-select"
      @input="setLocale"
    >
      <template
        slot="item"
        slot-scope="data"
      >
        <v-list-tile-avatar>
          <v-img
            :src="`/static/locale/${data.item.locale}.png`"
            max-width="32"
            max-height="32"
          />
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>{{ data.item.displayName }}</v-list-tile-title>
        </v-list-tile-content>
      </template>
    </v-select>
  </v-layout>
</template>

<script>
export default {
  props: {
    /** Whether to show a smaller widget. */
    small: {
      type: Boolean,
      default: false,
    },
    dark: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    locales() {
      const locales = [];
      for (let loc in this.$i18n.messages) {
        locales.push({
          locale: loc,
          displayName: this.$i18n.messages[loc]._displayName,
        });
      }
      return locales;
    },
  },
  methods: {
    setLocale(locale) {
      this.$store.commit('SET_LOCALE', locale);

      if (this.small) {
        this.$nextTick(() => {
          this.programmaticallyBlurSelect();
        });
      }
    },
    onSmallWidgetClicked() {
      // Note: This will only open the v-select's menu at the correct
      //   coordinates when the v-select is visible. Hiding it would
      //   move the v-menu's position to the upper left corner.
      this.programmaticallyClickSelect();
    },
    programmaticallyClickSelect() {
      this.$refs.select.onClick();
    },
    programmaticallyBlurSelect() {
      this.$refs.select.blur();
    },
  },
};
</script>

<style>
/**
 * HACK: Make the 'small' v-select invisible, but still exist in the DOM.
 *
 * This allows Vuetify to correctly position the v-menu when clicking the
 * v-select programmatically, while effectively hiding the v-select and
 * taking as little space as possible. If we'd just hide it via
 * display: none, Vuetify would place the v-menu at the wrong coordinates,
 * the v-select must be there to place it correctly.
 */
.v-select.small {
  opacity: 0;
}
.v-select.small .v-select__slot {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/LanguageSelect.vue